// Printed cookbook sizes (same keys as the API's COOKBOOK_SIZES). `ratio` is the
// page's width / height, bleed included, for drawing pages at the right shape.
export const COOKBOOK_SIZES = [
  {
    value: 'square',
    name: 'Square',
    label: '8.5 x 8.5 in',
    detail: 'Our original size. Big photos, easy to prop open.',
    ratio: 1,
  },
  {
    value: 'letter',
    name: 'Classic cookbook size',
    label: '8.5 x 11 in',
    detail: 'Tall like a classic cookbook, with the biggest photos.',
    ratio: 8.75 / 11.25,
  },
  {
    value: 'trade',
    name: 'Compact',
    label: '6 x 9 in',
    detail: 'A smaller book that fits on any shelf.',
    ratio: 6.25 / 9.25,
  },
]

export const cookbookSize = (key) =>
  COOKBOOK_SIZES.find((s) => s.value === key) || COOKBOOK_SIZES[0]
